import { FC, memo } from 'react'

import { ArrowContainerBack, ArrowLeftIcon } from './styles'

interface Props {
    onClick?: () => void
}

const AvailabilityCalendarBack: FC<Props> = ({ onClick }) => {
    return (
        <ArrowContainerBack onClick={onClick}>
            <ArrowLeftIcon />
        </ArrowContainerBack>
    )
}

export default memo(AvailabilityCalendarBack)
